/*
 * @Author: your name
 * @Date: 2022-01-28 15:32:26
 * @LastEditTime: 2024-11-21 21:06:58
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\filterField\BsyFilterText\index.jsx
 */

import React from 'react'
import { BsyUtils } from '../../../utils/Utils';
import BsyMultiTextEditor from '../../BsyMultiTextEditor';
import BsySelectCheckBox from '../../BsySelectCheckBox';
import BsySelectListCheckBox from '../../BsySelectListCheckBox';
import BsyFilterBase from '../BsyFilterBase';

import './index.css'
import { BsyConfig } from '../../../global/BsyConfig';

export class BsyFilterComboCheck extends BsyFilterBase {
    constructor(props) {
        super({
            minRow: 10,
            onStopEdit: null,
            valueMode: BsyConfig().CONST.FILTER_VALUE_MODE.ITEM,
            customItem: {
                text: React.language("unfilled"),
                value: "hasEmpty"
            },
            ...props
        })

        this.dashText = null;
    }

    doFilterRely = (t, rel,widgetFilter) => {
        this.filterRely = t;
        this.rel = rel;
        this.dashText && this.dashText.doFilterRely && this.dashText.doFilterRely(t, rel,widgetFilter)
    }

    _getAvailableMethods = () => {
        return [BsyConfig().CONST.FILTER_METHOD.IN,
        BsyConfig().CONST.FILTER_METHOD.ALL,
        BsyConfig().CONST.FILTER_METHOD.EQ,
        BsyConfig().CONST.FILTER_METHOD.EP,
        BsyConfig().CONST.FILTER_METHOD.NEP]
    }



    getValue = () => {
        let t = this.options;
        if (this.dashText) {
            let e = this.dashText.getValue()
                , i = BsyConfig().CONST.FILTER_VALUE_MODE;
            switch (this.valueMode) {
                case i.ITEM:
                    switch (this.method) {
                        case BsyConfig().CONST.FILTER_METHOD.EQ:
                        case BsyConfig().CONST.FILTER_METHOD.ALL:
                        case BsyConfig().CONST.FILTER_METHOD.IN:

                            if (BsyUtils.isObjectEmpty(e))
                                return { items: [], hasEmpty: false };
                            let e1 = [].concat(e)
                                , t = !1
                                , i = e.indexOf(BsyConfig().CONST.PARAMETER.EMPTY);
                            if (i > -1) {
                                t = !0
                                e1.splice(i, 1)
                            }
                            return {
                                hasEmpty: t,
                                items: e1
                            }
                        // return e;
                        default:
                            return null
                    }
          
                case i.CUSTOM:
                    switch (this.method) {
                        case BsyConfig().CONST.FILTER_METHOD.EQ:
                        case BsyConfig().CONST.FILTER_METHOD.IN:
                        case BsyConfig().CONST.FILTER_METHOD.ALL:
                            return {
                                items: e
                            };
                        default:
                            return null
                    }
 
                default:
            }
        }
        return null
    }

    getContext = (e) => {
        this.dashText = e;
        if (this.filterRely) {
            this.doFilterRely(this.filterRely, this.rel)
        }

    }

    renderCont = () => {
        let e = this
        let i = this.options;
        let a = BsyConfig().CONST.FILTER_VALUE_MODE;
        let c = this._getAsyncConfig()
        if (BsyUtils.isObjectEmpty(c)) {
            this.dashText = null;
            return <span className='error-tip'>{React.language("field.deleted.tip1")}</span>;
        }
        let val = this.getMiddleValue() || {};
        switch (e.valueMode) {
            case a.ITEM:
                switch (e.method) {
                    case BsyConfig().CONST.FILTER_METHOD.EQ:
                    case BsyConfig().CONST.FILTER_METHOD.ALL:
                    case BsyConfig().CONST.FILTER_METHOD.IN:
                        // this._createComboCheck();
                        let vals = [];
                        if (val.hasEmpty) {
                            vals.push(BsyConfig().CONST.PARAMETER.EMPTY)
                        }
                        if (val.items)
                            vals = vals.concat(val.items);
                        if (i.height > i.minRow) {
                            return <BsySelectListCheckBox
                                getContext={this.getContext}
                                theme={this.props.theme}
                                hasLimit={!0}
                                asyncResultKey={i.asyncResultKey || "items"}
                                value={vals}
                                hasSelectEmpty={false}
                                onBeforeAsync={i.onBeforeAsync}
                                onStopEdit={e1 => {
                                    e.value = e.getValue()
                                    BsyUtils.applyFunc(e, i.onStopEdit, [{
                                        value: e.getValue(),
                                        valueMode: e.valueMode,
                                        method: e.method,
                                    }, i], !1)
                                }}
                                async={c}
                            />
                        } else {
                            return <BsySelectCheckBox
                                getContext={this.getContext}
                                theme={this.props.theme}
                                hasLimit={!0}
                                value={vals}
                                // hasDefault={!0}
                                hasSelectAll={true}
                                onBeforeAsync={i.onBeforeAsync}
                                asyncResultKey={i.asyncResultKey || "items"}
                                height={'34px'}
                                onStopEdit={e1 => {
                                    e.value = e.getValue()
                                    BsyUtils.applyFunc(e, i.onStopEdit, [{
                                        value: e.getValue(),
                                        valueMode: e.valueMode,
                                        method: e.method,
                                    }, i], !1)
                                }}
                                async={c}
                            />
                        }
           
                    default:
                        break;
                }
                break;
            case a.CUSTOM:
                switch (e.method) {
                    case BsyConfig().CONST.FILTER_METHOD.EQ:
                    case BsyConfig().CONST.FILTER_METHOD.IN:
                    case BsyConfig().CONST.FILTER_METHOD.ALL:
                        return <BsyMultiTextEditor
                            getContext={this.getContext}
                            theme={this.props.theme}
                            width={"100%"}
                            height={34}
                            value={val.items ? val.items : []}
                            asyncResultKey={i.asyncResultKey || "items"}
                            autoWrap={i.height > i.minRow}
                            onStopEdit={(t) => {
                                e.value = e.getValue();
                                BsyUtils.applyFunc(this, this.props.onStopEdit, [{
                                    value: e.getValue(),
                                    method: e.method,
                                    valueMode: e.valueMode
                                }, i], !1)
                            }}
                        />
                        // this.dashCombocheck = new FX.MultiTextEditor({
                        //     renderEl: t("<div />").appendTo(this.$content),
                        //     width: "100%",
                        //     autoWrap: i.sizeY > i.minRow,
                        //     height: i.sizeY > i.minRow ? this.getDashContentHeight() : 32,
                        //     onStopEdit: function () {
                        //         FX.Utils.applyFunc(e, i.onStopEdit, [], !1)
                        //     }
                        // });
            
                    default:
                        break
                }
                break
            default:
        }
    }
    render() {
        return (<>
            {
                this.createTitleBar()
            }
            <div className='bsy-dash-cont' >
                {
                    this.renderCont()
                }
            </div>
        </>)
    }
}

